import React, { useEffect, useState } from "react";

export default function PrioritySummaryTable({ propData, delayCount }) {
  return (
    <div
      className="flex flex-col w-full gap-1 my-2 overflow-y-scroll"
      style={propData.length > 3 ? { height: "200px" } : {}}
    >
      <div className="flex flex-col">
        <div className="flex w-full gap-1">
          <h3 className="flex justify-center items-center text-sm bg-green-200 w-56 h-[2.5rem]">
            CLIENT
          </h3>
          <h3 className="flex justify-center items-center text-sm bg-green-200 w-56 h-[2.5rem]">
            CURRENT MONTH COUNT
          </h3>
          <h3 className="flex justify-center items-center text-sm bg-green-200 w-56 h-[2.5rem]">
            DELAYED COUNT
          </h3>
        </div>
        {propData.map((data, index) => (
          <div className="flex w-full gap-1 relative mb-2 mt-2" key={index}>
            <p className="bg-slate-200 flex items-center justify-center w-56 h-[2.5rem]">
              {data.client_name}
            </p>
            <p className="bg-slate-200 flex items-center justify-center w-56 h-[2.5rem]">
              {data.matched_employee_count}
            </p>
            <p className="bg-slate-200 flex items-center justify-center w-56 h-[2.5rem]">
              {/* {delayCount && delayCount?.length} */}
              {data.matched_employee_count}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
